import React, { useState } from 'react';
import { ArticleCard } from '../components/ArticleCard';
import { FilterIcon, ExternalLinkIcon } from 'lucide-react';
export function Portfolio() {
  const [activeFilter, setActiveFilter] = useState('all');
  const publishedArticles = [{
    id: 1,
    title: '18 Years of M-Pesa: The Simple Idea That Changed a Nation',
    publisher: 'Yehtu Tech',
    category: 'Brand Storytelling for Campaigns',
    description: 'An exploration of how M-Pesa revolutionized financial inclusion in Kenya and beyond.',
    url: 'https://story.yehtu.tech/18-years-of-m-pesa-the-simple-idea-that-changed-a-nation/'
  }, {
    id: 2,
    title: 'Why Ksh100 Note Is Worth Twice As Much To A Woman As It Is To A Man: Money Management',
    publisher: 'Money254',
    category: 'Creative Copywriting',
    description: 'A thought-provoking analysis of gender differences in financial management and priorities.',
    url: 'https://www.money254.co.ke/post/why-ksh100-note-is-worth-twice-as-much-to-a-woman-as-it-is-to-a-man-money-management'
  }, {
    id: 3,
    title: 'How To Apply For Affordable Housing Units: A Step-By-Step Guide',
    publisher: 'Ghafla',
    category: 'SEO Website Content',
    description: 'A comprehensive guide to navigating the affordable housing application process in Kenya.',
    url: 'https://www.ghafla.co.ke/ke/how-to-apply-for-affordable-housing-units-a-step-by-step-guide/'
  }, {
    id: 4,
    title: 'The History And Evolution Of Saba Saba: 1990-2024',
    publisher: 'Ghafla',
    category: 'NGO & Government',
    description: "A deep dive into the historical significance and evolution of Saba Saba in Kenya's political landscape.",
    url: 'https://www.ghafla.co.ke/ke/the-history-and-evolution-of-saba-saba-1990-2024/'
  }, {
    id: 5,
    title: 'YEA App: The New Revolutionary Banking Solution For Young Adults',
    publisher: 'Ghafla',
    category: 'Brand Storytelling for Campaigns',
    description: 'An exploration of a new banking solution designed specifically for the needs and habits of young adults.',
    url: 'https://www.ghafla.co.ke/sponsored/yea-app-the-new-revolutionary-banking-solution-for-young-adults/'
  }, {
    id: 6,
    title: "A Day's Work: The Steep Emotional Price Paid By Home Care Nurse",
    publisher: 'Kenyans.co.ke',
    category: 'Creative Copywriting',
    description: 'A poignant look at the emotional challenges faced by healthcare workers in home settings.',
    url: 'https://www.kenyans.co.ke/news/68375-day-work-steep-emotional-price-paid-home-care-nurse'
  }, {
    id: 7,
    title: 'The Untold Sins: Wagalla Massacre Horrors',
    publisher: 'Kenyans.co.ke',
    category: 'NGO & Government',
    description: "An in-depth investigation into one of Kenya's darkest historical events and its lasting impact.",
    url: 'https://www.kenyans.co.ke/news/67743-kenya-govt-untold-sins-wagalla-massacre-horrors-day-one-three'
  }, {
    id: 8,
    title: 'How Did Mombasa Make The Cut To Become A City?',
    publisher: 'Kenyans.co.ke',
    category: 'SEO Website Content',
    description: "An analysis of Mombasa's journey to city status and the factors that contributed to its urban development.",
    url: 'https://www.kenyans.co.ke/news/67547-pray-tell-how-did-mombasa-make-cut-become-city'
  }];
  // Define the specific categories requested
  const categories = ['all', 'Brand Storytelling for Campaigns', 'Creative Copywriting', 'SEO Website Content', 'NGO & Government'];
  // Filter based on category
  const filteredItems = publishedArticles.filter(item => activeFilter === 'all' || item.category === activeFilter);
  return <div className="w-full bg-white" data-id="element-1303">
      {/* Header */}
      <section className="bg-gray-50 py-20 md:py-28 w-full" data-id="element-1304">
        <div className="container mx-auto px-4" data-id="element-1305">
          <div className="max-w-3xl mx-auto text-center" data-id="element-1306">
            <h1 className="text-4xl md:text-5xl font-bold mb-6 leading-tight elegant-heading" data-id="element-1307">
              Our Published Work
            </h1>
            <div className="elegant-divider" data-id="element-1308"></div>
            <p className="text-xl text-gray-700 max-w-2xl mx-auto" data-id="element-1309">
              A collection of our articles, features, and stories published
              across East Africa's leading platforms.
            </p>
          </div>
        </div>
      </section>
      {/* Filter */}
      <section className="py-8 border-b border-gray-100 w-full sticky top-16 bg-white z-40 shadow-sm" data-id="element-1310">
        <div className="container mx-auto px-4" data-id="element-1311">
          <div className="flex justify-center items-center gap-4" data-id="element-1312">
            <div className="flex items-center gap-2 overflow-x-auto pb-2 md:pb-0 no-scrollbar" data-id="element-1313">
              <FilterIcon size={18} className="text-gray-500 hidden md:block" data-id="element-1314" />
              <div className="flex gap-2 flex-nowrap" data-id="element-1315">
                {categories.map((category, index) => <button key={index} onClick={() => setActiveFilter(category)} className={`px-4 py-2 rounded-md transition-colors whitespace-nowrap ${activeFilter === category ? 'bg-gray-900 text-white' : 'bg-white text-gray-700 hover:bg-gray-100 border border-gray-200'}`} data-id="element-1316">
                    {category === 'all' ? 'All Articles' : category}
                  </button>)}
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Articles Grid */}
      <section className="py-16 w-full" data-id="element-1317">
        <div className="container mx-auto px-4" data-id="element-1318">
          {filteredItems.length > 0 ? <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1319">
              {filteredItems.map(item => <ArticleCard key={item.id} title={item.title} publisher={item.publisher} description={item.description} url={item.url} category={item.category} data-id="element-1320" />)}
            </div> : <div className="text-center py-12" data-id="element-1321">
              <h3 className="text-xl font-medium text-gray-700 mb-2" data-id="element-1322">
                No articles found
              </h3>
              <p className="text-gray-500" data-id="element-1323">
                Try adjusting your filter criteria
              </p>
            </div>}
        </div>
      </section>
      {/* Featured Publications */}
      <section className="bg-gray-50 py-16 w-full" data-id="element-1324">
        <div className="container mx-auto px-4 text-center" data-id="element-1325">
          <h2 className="text-3xl font-bold mb-12 elegant-heading" data-id="element-1326">
            Featured In
          </h2>
          <div className="elegant-divider" data-id="element-1327"></div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8" data-id="element-1328">
            <div className="flex flex-col items-center justify-center p-6 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow elegant-card" data-id="element-1329">
              <div className="h-12 flex items-center justify-center mb-4" data-id="element-1330">
                <img src="https://www.kenyans.co.ke/files/kenyans-newlogo-2019-250x90-2_0.png" alt="Kenyans.co.ke" className="h-full object-contain" data-id="element-1331" />
              </div>
              <a href="https://www.kenyans.co.ke/" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-500 hover:accent-color flex items-center elegant-button" data-id="element-1332">
                <span data-id="element-1333">Visit</span>
                <ExternalLinkIcon size={14} className="ml-1" data-id="element-1334" />
              </a>
            </div>
            <div className="flex flex-col items-center justify-center p-6 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow elegant-card" data-id="element-1335">
              <div className="h-12 flex items-center justify-center mb-4" data-id="element-1336">
                <img src="https://cdn.prod.website-files.com/6038bfe131e18166ff8529be/64510cbab819ac3906b55c50_Money254%20New%20Logo%2BLinear%20Logo%20White.webp" alt="Money254" className="h-full object-contain" data-id="element-1337" />
              </div>
              <a href="https://www.money254.co.ke/" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-500 hover:accent-color flex items-center elegant-button" data-id="element-1338">
                <span data-id="element-1339">Visit</span>
                <ExternalLinkIcon size={14} className="ml-1" data-id="element-1340" />
              </a>
            </div>
            <div className="flex flex-col items-center justify-center p-6 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow elegant-card" data-id="element-1341">
              <div className="h-12 flex items-center justify-center mb-4" data-id="element-1342">
                <img src="https://www.ghafla.co.ke/ke/wp-content/uploads/sites/4/2023/04/cropped-screenshot.png" alt="Ghafla" className="h-full object-contain" data-id="element-1343" />
              </div>
              <a href="https://www.ghafla.co.ke/" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-500 hover:accent-color flex items-center elegant-button" data-id="element-1344">
                <span data-id="element-1345">Visit</span>
                <ExternalLinkIcon size={14} className="ml-1" data-id="element-1346" />
              </a>
            </div>
            <div className="flex flex-col items-center justify-center p-6 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow elegant-card" data-id="element-1347">
              <div className="h-12 flex items-center justify-center mb-4" data-id="element-1348">
                <img src="https://story.yehtu.tech/storage/2024/10/Yehtu-Logo-Dark-01-01.svg" alt="Yehtu Tech" className="h-full object-contain" data-id="element-1349" />
              </div>
              <a href="https://story.yehtu.tech/" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-500 hover:accent-color flex items-center elegant-button" data-id="element-1350">
                <span data-id="element-1351">Visit</span>
                <ExternalLinkIcon size={14} className="ml-1" data-id="element-1352" />
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>;
}